<template>
  <ul class="ChecksComponent">
    <li v-for="(item, i) in items" :key="i" class="row" :class="{ checked: item.check !== 'cross' }">
      <i :class="[item.check !== 'cross' ? 'icon-check-02' : 'icon-close-03']" />

      <span ref="textElements" :alt="item.text">
        {{ item.text }}
      </span>
      <!-- <a
        class="more"
        v-if="isTextTruncated[i]"
        @click="openModal(i, item.text)"
      >
        Ver más <BaseTooltip :tooltip="item.text" />
      </a> -->

      <!-- <ModalComponent
        v-if="showModal.index === i"
        :value="showModal.isOpen"
        @update:value="(val) => closeModal()"
      >
        <p>{{ selectedText }}</p>
      </ModalComponent> -->
    </li>
  </ul>
</template>

<script setup lang="ts">
import { nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
//import ModalComponent from '@/modules/core/components/utils/ModalComponent.vue'
// import BaseTooltip from '@/modules/core/components/ui/BaseTooltip.vue'

interface PropsInterface {
  items: any[]
}
const props = withDefaults(defineProps<PropsInterface>(), {})

// const showModal = ref({ isOpen: false, index: -1 })
// const selectedText = ref('')

const isTextTruncated = ref<boolean[]>([])
const textElements = ref<(HTMLSpanElement | null)[]>([])

const checkTextOverflow = () => {
  nextTick(() => {
    isTextTruncated.value = textElements.value.map((element) => {
      if (element) {
        return element.scrollHeight > element.clientHeight
      }
      return false
    })
  })
}

const handleResize = () => {
  checkTextOverflow()
}

// const openModal = (index: number, text: string) => {
//   selectedText.value = text
//   showModal.value = { isOpen: true, index }
// }

// const closeModal = () => {
//   showModal.value = { isOpen: false, index: -1 }
// }

onMounted(() => {
  checkTextOverflow()
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})

// Opcional: Verifica los cambios en los elementos
watch(() => props.items, checkTextOverflow)
</script>

<style lang="scss" scoped>
.ChecksComponent {
  all: unset;

  li:nth-child(even) {
    background-color: $color-primary-lighter;
  }

  i {
    font-size: $font-size-xl;

    &::before {
      color: $color-grey-500;
    }
  }

  .row {
    padding: $spacing-m;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: $gap-0 $gap-10;
    min-height: $size-100;

    &.checked {
      i {
        &::before {
          color: $color-primary-light;
        }
      }

      span {
        color: $color-primary-dark;

        // display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;

        // overflow: hidden;
        font-size: $font-size-s;
      }
    }

    &:not(.checked) {
      color: $color-neutral;

      i{
        &::before{
          color: $color-neutral;
        }
      }

      span {
        // display: -webkit-box;
        // -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-size: $font-size-s;
      }
    }

    .more {
      position: relative;
      top: $size-05;
      text-align: right;
      font-size: $font-size-xs;
      color: $color-primary;
      font-weight: $font-weight-700;
      display: block;
      grid-column: 1/3;
      cursor: pointer;
    }
  }
}
</style>
